import FondsCharts from "../../components/Homes/FondsCharts";
import FondPersoCharts from "../../components/Homes/FondPersosCharts";
import { useAuth } from "../../contexts/auth/useAuth";
import { roles } from "../../types/Users";
import DemandeBarChart from "../../components/Demandes/DemandeBarChart";
import FondBarCharts from "../../components/Homes/FondBarCharts";
function HomeUsers(){
  const year=new Date().getFullYear();
  const {hasRole} = useAuth();

  return (
    <>
      <h3>Demandes</h3>
      <DemandeBarChart year={year}></DemandeBarChart>
      <hr />
      <FondPersoCharts></FondPersoCharts>
      <hr />



      {hasRole(roles.Manager)?
        <>
        <FondsCharts></FondsCharts>
        <FondBarCharts></FondBarCharts>
        </>
      :null}
    </>
  )
}
export default HomeUsers;